import { Record } from 'immutable';

import { DatablockListEntity } from '../components/datablock-list/datablock-list.entity';

export const DatablockSliceKey = 'main';

export interface IDatablockOriginalSliceState {
	loading: boolean;
	actionInProgress: boolean;
	list: DatablockListEntity;
	isLoadingPersistence: boolean;
}

export const defaults: IDatablockOriginalSliceState = {
	loading: false,
	actionInProgress: false,
	list: DatablockListEntity.build([]),
	isLoadingPersistence: false,
};
export class DatablockOriginalSliceState extends Record<IDatablockOriginalSliceState>(
	defaults
) {
	public static readonly key = DatablockSliceKey;

	public setLoading(isLoading: boolean): DatablockOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setActionInProgress(
		isActionInProgress: boolean
	): DatablockOriginalSliceState {
		return this.set('actionInProgress', isActionInProgress);
	}

	public setDatablockList(
		datablockList: DatablockListEntity
	): DatablockOriginalSliceState {
		return this.set('list', datablockList);
	}

	public setLoadingPersistence(
		isLoading: boolean
	): DatablockOriginalSliceState {
		return this.set('isLoadingPersistence', isLoading);
	}
}
